export const unWrapNull = <T>(value?: T | null): T | undefined => {
  if (value === null) return undefined;
  return value as T | undefined;
};
